<template>
    <PatientSummary :ServiceID="AppServiceID"></PatientSummary> 
</template>

<script>
import PatientSummary from '@/components/Dental/PatientSummary.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function (){
        return {
            AppServiceID :'', 
        }
    },
    components: {  
        PatientSummary
    },
created: function() { 
    this.$emit('update:layout', LayoutDefault);
    this.AppServiceID = this.$store.getters.GetDentalID;
},   
beforeCreate: function() {
    this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
    this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
    },
}
</script>

<style>

</style>
